export enum ExcelGenerateConfig {
	TAX = 'tax',
	TM_TAX = 'tm-tax',
	HOLDINGS_360 = 'holdings360',
	HOLDINGS_PC360 = 'holdingsPc360',
	MVAL = 'mval',
	AU_MVAL = 'au-mval'
}
